import api from '../../../App/socket';

export const getTransportUsersList = (searchText = '') => api.send({
    api: 'db',
    model: 'User',
    action: 'Read',
    options: {
        limit: 10,
        attributes: ['person.first_name', 'person.last_name'],
        where: {
            $or: [
                {
                    'person.first_name': {
                        $regex: searchText,
                        $options: 'i',
                    },
                },
                {
                    'person.last_name': {
                        $regex: searchText,
                        $options: 'i',
                    },
                },
            ],
            groups: {
                $in: ['5bb5cf6087ccbe393434b649'],
            },
            ref_user_status: '5bbb09fb60dc39407f5623aa',
        },
    },
}).then((res) => res).catch((res) => res);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_transport_users_list_request.js